/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['mn.', 'h.', 'mrg.', 'sd.', 'kv.', 'n.'],
    ['miðn.', 'hád.', 'að morgni', 'síðd.', 'að kv.', 'að nóttu'],
    ['miðnætti', 'hádegi', 'að morgni', 'síðdegis', 'að kvöldi', 'að nóttu']
  ],
  [
    ['mn.', 'hd.', 'mrg.', 'sd.', 'kv.', 'n.'], ['miðn.', 'hád.', 'morg.', 'síðd.', 'kv.', 'nótt'],
    ['miðnætti', 'hádegi', 'morgunn', 'eftir hádegi', 'kvöld', 'nótt']
  ],
  [
    '00:00', '12:00', ['06:00', '12:00'], ['12:00', '18:00'], ['18:00', '24:00'],
    ['00:00', '06:00']
  ]
];
